import Axios from 'axios';
import { sendRequest } from './general';


export const getDeals = async (params) => await sendRequest(Axios.get('/api/deal', { params }));

export const getPipelineLTAvailableSpace = async (params) => await sendRequest(Axios.get('/api/pipeline/lt-available-space', { params }));

export const getExportDeals = async (params) => await sendRequest(Axios.get('/api/deal', { responseType: 'arraybuffer', params })); 
